import { render, staticRenderFns } from "./SortFile.vue?vue&type=template&id=d3933c9e&scoped=true&"
import script from "./SortFile.vue?vue&type=script&lang=js&"
export * from "./SortFile.vue?vue&type=script&lang=js&"
import style0 from "./SortFile.vue?vue&type=style&index=0&id=d3933c9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3933c9e",
  null
  
)

export default component.exports